// absoluteAvatarURL — turn a `profiles.avatar_url` value into a URL the
// iOS Live Activity widget extension can actually load.
//
// avatar_catalog stores image_url as a relative path (e.g.
// `/profile-avatars/sunshine.svg`) so the DB doesn't need to know the
// deploy origin. That works in the Capacitor webview because the
// webview's root resolves to the bundled app. The widget extension is
// a SEPARATE iOS process with no webview context — `/foo` doesn't
// resolve to anything reachable, so AsyncImage silently fails.
//
// This helper prepends the production origin to relative paths and
// passes absolute URLs through. Pass to whatever ships an avatar URL
// across the JS → native bridge (BoodaTimer.startSession's timerOwners,
// updateSession's helpers/timerOwners, etc.).

// Bare apex domain. www.booda.app fails DNS resolution on at least
// one tested iOS device ("Resolved 0 endpoints" / NSURLErrorDomain
// -1003) — apex resolves reliably and Vercel's 307 redirect to www
// gets followed by URLSession, but the redirect target's resolution
// failure still kills the load. Going apex-direct bypasses both the
// extra hop and the broken-www case.
const PROD_ORIGIN = "https://booda.app";

export function absoluteAvatarURL(raw) {
  if (!raw) return undefined;
  const s = String(raw).trim();
  if (!s) return undefined;
  if (/^https?:\/\//i.test(s)) return s;
  if (s.startsWith("/")) return `${PROD_ORIGIN}${s}`;
  return `${PROD_ORIGIN}/${s}`;
}
